/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import teaserCardStyle from "./teaserCardStyle";
import { Link } from "react-router";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import GradientPaper from "@/src/components/GradientComponents/GradientPaper";
import IconWrapper, { IconWrapperProps } from "@/src/components/IconWrapper/IconWrapper";

type TeaserCardProps = {
  heading: string;
  subHeading?: string;
  headingColor?: "default" | "primary";
  twoLineHeading?: boolean;
  icon: IconWrapperProps["icon"];
  iconCircled?: boolean;
  linkTo?: string;
  mobileCtaText?: string;
  linkType?: string;
  displayMobileCta?: boolean;
};

const TeaserCard = ({
  heading,
  subHeading,
  icon,
  iconCircled = false,
  linkTo = "",
  mobileCtaText = "JETZT STARTEN",
  linkType,
  displayMobileCta = true,
}: TeaserCardProps) => {
  const linked = linkTo ? "linked" : "notLinked";
  let paperLinkProps = {};

  if (linkTo) {
    paperLinkProps =
      linkType === "external"
        ? { component: "a", href: linkTo, target: "_blank" }
        : {
            component: Link,
            to: linkTo,
          };
  }

  return (
    <GradientPaper sx={{ ...teaserCardStyle.paper, ...teaserCardStyle[linked] }} {...paperLinkProps}>
      {iconCircled ? (
        <Box sx={teaserCardStyle.imageCircleContainer}>
          <IconWrapper icon={icon} sx={teaserCardStyle.icon} alt="" screenReaderHidden={true} />
        </Box>
      ) : (
        <Box sx={teaserCardStyle.imageContainer}>
          <IconWrapper icon={icon} sx={teaserCardStyle.icon} alt="" screenReaderHidden={true} />
        </Box>
      )}
      <Typography variant={"h5"} component={"h2"}>
        {heading}
      </Typography>
      {subHeading && (
        <>
          <Typography variant={"body1"} color={"textSecondary"} sx={teaserCardStyle.subHeading}>
            {subHeading}
          </Typography>
        </>
      )}
      {linkTo && displayMobileCta && <Typography sx={[teaserCardStyle.mobileCta, { display: { xs: "block", md: "none" } }]}>{mobileCtaText}</Typography>}
    </GradientPaper>
  );
};
export default TeaserCard;
